import { path } from 'ramda'

export const apiKey = state => path(['apiKey','apiKey'], state)


// WEBPACK FOOTER //
// ./src/modules/apiKey/selectors.js